import { render, staticRenderFns } from "./regimesContratacao.vue?vue&type=template&id=0296929b&scoped=true&"
import script from "./regimesContratacao.vue?vue&type=script&lang=js&"
export * from "./regimesContratacao.vue?vue&type=script&lang=js&"
import style0 from "./regimesContratacao.vue?vue&type=style&index=0&id=0296929b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0296929b",
  null
  
)

export default component.exports